export const LOADING = 'LOADING';
export const LOADING_COMPLETE = 'LOADING_COMPLETE';
export const ERROR = 'ERROR';
export const SUCCESS = 'SUCCESS';
export const SAVING = 'SAVING';
export const SAVE_SUCCESS = 'SAVE_SUCCESS';
